import axios from '@_system/axios/axios.js'
export default {
	path: '/invoicematch',
	list(data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	get(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	update(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.put(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	getgoodsspu(data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path + '/getgoodsspu', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	
	
	
	init(data = {}) {
		return new Promise((resolve, reject) => {
			axios.get('moduleConfig/admin/invoice.invoicematch', data, (res) => {
				resolve(res.data)
			}, reject, true)
		})
	},
	
	autoinvoice(data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path + '/autoinvoice', data, (res) => {
				resolve(res.data)
			},reject)
		})
	},	
	matchtype(data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path + '/matchtype', data, (res) => {
				resolve(res.data)
			},reject)
		})
	},	
	saveinvoiceinfo(data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path + '/saveinvoiceinfo', data, (res) => {
				resolve(res.data)
			},reject)
		})
	},	
	
	
	
	reissue(data = {}) {
		return new Promise((resolve) => {
			axios.post(this.path + '/reissue', data, (res) => {
				resolve(res.data)
			})
		})
	},

}
